import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import ApiError from '@/entities/errors/ApiError';
import InactivePlaceError from '@/entities/errors/InactivePlaceError';
import PlaceNotFoundError from '@/entities/errors/PlaceNotFoundError';
import UnknownUrlError from '@/entities/errors/UnknownUrlError';
import { HttpError } from '@/entities/types/HttpError';
import { Logger } from '@/logger';
import { Custom404 } from '@/pages/Custom404';
import { Custom500 } from '@/pages/Custom500';
class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }
    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }
    componentDidCatch(error) {
        Logger.error(error);
    }
    render() {
        const { children, fallbackComponent } = this.props;
        const { error, hasError } = this.state;
        const error404 = error instanceof UnknownUrlError ||
            error instanceof PlaceNotFoundError ||
            error instanceof InactivePlaceError ||
            error instanceof HttpError;
        if (error404) {
            return _jsx(Custom404, {});
        }
        if (error instanceof ApiError) {
            return _jsx(Custom500, {});
        }
        if (hasError) {
            return fallbackComponent;
        }
        return children;
    }
}
export default ErrorBoundary;
